<button type="button" mat-button mat-raised-button color="primary" class="display-text-button" (click)="openDialog()">
	<span>Compare Children</span>
</button>